<script lang="ts">
    import { Badge,  Col, Image, Row } from "sveltestrap";
    import data from "../../../../Data/Project/Project.json";
    import Card from "../../../Core/Card.svelte"
    import ProjectStatus from "./ProjectStatus.svelte";
    import Customers from "./Customers.svelte";
    let imgPath:string = "/assets/images/user"
    export let itemId:string 

</script>
<Col sm="12">
    <Card>
      <div slot="contentbody">
        <div class="tab-content" id="tabContent">
          {#each data.alldata as allItem}
              <div class="tab-pane fade {itemId === allItem.id  ? "active show" : ""}" id={allItem.id} role="tabpanel" aria-labelledby={allItem.id}>
                  <Row>
                      {#each allItem.projecttabdata as projectItem}
                          <Col xxl="4" md="6">
                              <div class="project-box">
                                  <Badge color={projectItem.color}>{projectItem.badgename}</Badge>
                                  <h6>{projectItem.title}</h6>
                                  <div class="media">
                                      <Image class="img-20 me-2 rounded-circle" src="{imgPath}/{projectItem.img}"  />
                                      <div class="media-body">
                                          <p>{projectItem.add}</p>
                                      </div>
                                  </div>
                                  <p>{projectItem.detail}</p>
                                  <Row class="details">
                                      {#each projectItem.issuedata as textdata}
                                          <Col xs="6"><span>{textdata.title} </span></Col>
                                          <Col xs="6" class={textdata.color}>{textdata.num} </Col>
                                      {/each}
                                  </Row>
                                  <Customers customerItem={projectItem}/>
                                  <ProjectStatus projectItem={projectItem}/>
                              </div>
                          </Col>
                      {/each}
                  </Row>
              </div>
          {/each}
        </div>
      </div>
    </Card>
</Col>
